import { all, takeLatest } from "redux-saga/effects";

import {
  GET_APPLICATIONS,
  GET_APPLICATION_DETAILS,
  ADD_MEETING,
  ADD_MESSAGE,
  CHECK_EMAIL,
  CHANGE_NOTIFICATIONS_STATUS,
  ADD_NOTIFICATIONS_SINGLE,
  ADD_NOTIFICATIONS_MULTIPLE,
  CHANGE_MEETING_STATUS,
  CHANGE_PASSWORD,
  CHANGE_APP_STATUS,
  EDIT_PROFILE,
  FORGOT_PASSWORD,
  GET_COUNTRIES,
  GET_PROGRAM_TYPES,
  GET_PROGRAMS,
  GET_ONLINE_USERS,
  GET_NOTIFICATIONS,
  GET_MEETINGS_INVITES,
  GET_MEETINGS_REQUESTS,
  GET_ALL_MEETINGS_AND_COUNT,
  GET_MEETING_DETAILS,
  GET_MEETINGS_BASED_ON_DATE,
  GET_PROFILE,
  GET_UNIVERSITIES,
  GET_UNIVERSITIES_GRID,
  GET_UPCOMING_MEETINGS,
  GET_ALL_UNIVERSITIES,
  GET_UNIVERSITY_DETAILS,
  GET_UNIVERSITY_DETAILS_ADMIN,
  GET_MESSAGES,
  GET_UNREAD_MESSAGES,
  GET_POPULAR_SUBS,
  GET_USERS,
  GET_SCHOOLS,
  GET_SCHOOL,
  ADD_SCHOOL,
  EDIT_SCHOOL,
  CHANGE_SCHOOL_STATUS,
  GET_VISA_INFO,
  ADD_VISA_INFO,
  EDIT_VISA_INFO,
  DELETE_VISA_INFO,
  GET_UNI_APPS_SHORTS,
  LOGIN,
  LOGOUT,
  RESET_PASSWORD,
  RESCHEDULE_MEETING,
  UPLOAD_IMAGE,
  UPLOAD_FILE,
  VERIFY_OTP,
  GET_TAGS,
  GET_UNIS_BY_BUDGET,
  GET_POPULAR_COUNTRIES,
  GET_PAYMENT_PLANS,
  REFRESH_TOKEN,
  UNI_SEARCH,
  EXPLORE_SEARCH,
  GET_ALL_STUDENTS,
  GET_ACTIVE_STUDENTS,
  GET_STUDENTS_ANALYTICS,
  GET_STUDENT_DETAILS,
  UPDATE_STUDENT,
  GET_TIMESLOTS,
  GET_ALL_TIMESLOTS,
  ADD_TIMESLOT,
  REQ_LOR,
  GET_DIFF_UNI_VALUES,
  ADD_UNIVERSITY,
  ADD_UNIVERSITY_SHEET,
  EDIT_UNIVERSITY,
  ADD_COUNTRY,
  GET_CONTINENTS,
  GET_REGIONS,
  EDIT_COUNTRY,
  UPLOAD_UNIVERSITY_IMAGES,
  GET_INTERNSHIPS,
  GET_JOB_COMPANIES,
  GET_JOB_TYPES,
  UPLOAD_INTERNSHIPS,
  GET_DASH_INFO,
  GET_REG_PER_MONTH,
} from "../constants";
import {
  AdminMiddleware,
  ApplicationMiddleware,
  AuthMiddleware,
  ChatbotMiddleware,
  InternshipsMiddleware,
  OthersMiddleware,
  MeetingMiddleware,
  NotificationsMiddleware,
  ProfileMiddleware,
  SchoolMiddleware,
  SearchMiddleware,
  StudentMiddleware,
  UniversityMiddleware,
} from "../middlewares";

export function* Sagas() {
  yield all([
    //login flow
    yield takeLatest(LOGIN, AuthMiddleware.SignIn),
    yield takeLatest(REFRESH_TOKEN, AuthMiddleware.refreshToken),
    yield takeLatest(FORGOT_PASSWORD, AuthMiddleware.ForgotPassword),
    yield takeLatest(RESET_PASSWORD, AuthMiddleware.ResetPassword),
    yield takeLatest(VERIFY_OTP, AuthMiddleware.VerifyOtp),
    yield takeLatest(CHECK_EMAIL, AuthMiddleware.CheckEmail),
    yield takeLatest(LOGOUT, AuthMiddleware.Logout),

    //university
    yield takeLatest(GET_UNIVERSITIES, UniversityMiddleware.getUniversities),
    yield takeLatest(
      GET_UNIVERSITIES_GRID,
      UniversityMiddleware.getUniversitiesGrid
    ),
    yield takeLatest(
      GET_ALL_UNIVERSITIES,
      UniversityMiddleware.getAllUniversities
    ),
    yield takeLatest(
      GET_UNIVERSITY_DETAILS,
      UniversityMiddleware.getUniversityDetails
    ),
    yield takeLatest(
      GET_UNIVERSITY_DETAILS_ADMIN,
      UniversityMiddleware.getUniversityDetailsAdmin
    ),

    yield takeLatest(ADD_UNIVERSITY, UniversityMiddleware.addUniversity),
    yield takeLatest(
      ADD_UNIVERSITY_SHEET,
      UniversityMiddleware.addUniversitySheet
    ),
    yield takeLatest(EDIT_UNIVERSITY, UniversityMiddleware.editUniversity),
    yield takeLatest(
      GET_POPULAR_COUNTRIES,
      UniversityMiddleware.getPopularCountries
    ),
    yield takeLatest(GET_UNIS_BY_BUDGET, UniversityMiddleware.getUnisByBudget),
    yield takeLatest(
      UPLOAD_UNIVERSITY_IMAGES,
      UniversityMiddleware.uploadUniImage
    ),
    yield takeLatest(
      GET_UNI_APPS_SHORTS,
      UniversityMiddleware.getUniAppsShorts
    ),

    //user profile
    yield takeLatest(GET_PROFILE, ProfileMiddleware.getUserProfile),
    yield takeLatest(EDIT_PROFILE, ProfileMiddleware.editUserProfile),
    yield takeLatest(CHANGE_PASSWORD, ProfileMiddleware.changePassword),

    //notifications
    yield takeLatest(
      GET_NOTIFICATIONS,
      NotificationsMiddleware.getNotifications
    ),
    yield takeLatest(
      CHANGE_NOTIFICATIONS_STATUS,
      NotificationsMiddleware.changeNotificationsStatus
    ),
    yield takeLatest(
      ADD_NOTIFICATIONS_SINGLE,
      NotificationsMiddleware.addNotificationsSingle
    ),
    yield takeLatest(
      ADD_NOTIFICATIONS_MULTIPLE,
      NotificationsMiddleware.addNotificationsMultiple
    ),

    //students
    yield takeLatest(GET_ACTIVE_STUDENTS, StudentMiddleware.getActiveStudents),
    yield takeLatest(GET_ALL_STUDENTS, StudentMiddleware.getAllStudents),
    yield takeLatest(GET_STUDENT_DETAILS, StudentMiddleware.getStudentDetails),
    yield takeLatest(UPDATE_STUDENT, StudentMiddleware.updateStudent),
    yield takeLatest(
      GET_STUDENTS_ANALYTICS,
      StudentMiddleware.getStudentsAnalytics
    ),

    //meetings
    yield takeLatest(ADD_MEETING, MeetingMiddleware.addMeeting),
    yield takeLatest(RESCHEDULE_MEETING, MeetingMiddleware.rescheduleMeeting),
    yield takeLatest(GET_MEETINGS_INVITES, MeetingMiddleware.getMeetingInvites),
    yield takeLatest(
      GET_MEETINGS_REQUESTS,
      MeetingMiddleware.getMeetingRequests
    ),
    yield takeLatest(GET_MEETING_DETAILS, MeetingMiddleware.getMeetingDetails),
    yield takeLatest(
      GET_UPCOMING_MEETINGS,
      MeetingMiddleware.getUpcomingMeetings
    ),
    yield takeLatest(
      GET_ALL_MEETINGS_AND_COUNT,
      MeetingMiddleware.getAllMeetingsAndCount
    ),
    yield takeLatest(
      GET_MEETINGS_BASED_ON_DATE,
      MeetingMiddleware.getMeetingsBasedOnDate
    ),
    yield takeLatest(
      CHANGE_MEETING_STATUS,
      MeetingMiddleware.changeMeetingStatus
    ),

    // timeslots
    yield takeLatest(GET_TIMESLOTS, MeetingMiddleware.getTimeslots),
    yield takeLatest(GET_ALL_TIMESLOTS, MeetingMiddleware.getAllTimeslots),
    yield takeLatest(ADD_TIMESLOT, MeetingMiddleware.addTimeslot),

    //applications
    yield takeLatest(GET_APPLICATIONS, ApplicationMiddleware.getApplications),
    yield takeLatest(
      GET_APPLICATION_DETAILS,
      ApplicationMiddleware.getApplicationDetails
    ),
    yield takeLatest(
      CHANGE_APP_STATUS,
      ApplicationMiddleware.changeApplicationStatus
    ),
    yield takeLatest(REQ_LOR, ApplicationMiddleware.reqLOR),

    //chatbot
    yield takeLatest(GET_MESSAGES, ChatbotMiddleware.getMessages),
    yield takeLatest(GET_UNREAD_MESSAGES, ChatbotMiddleware.getUnreadMessages),
    yield takeLatest(ADD_MESSAGE, ChatbotMiddleware.addMessage),
    yield takeLatest(GET_USERS, ChatbotMiddleware.getUsers),

    //chatbot
    yield takeLatest(GET_INTERNSHIPS, InternshipsMiddleware.getInternships),
    yield takeLatest(GET_JOB_COMPANIES, InternshipsMiddleware.getJobCompanies),
    yield takeLatest(GET_JOB_TYPES, InternshipsMiddleware.getJobTypes),
    yield takeLatest(
      UPLOAD_INTERNSHIPS,
      InternshipsMiddleware.uploadInternships
    ),

    // others
    yield takeLatest(GET_COUNTRIES, OthersMiddleware.getCountries),
    yield takeLatest(ADD_COUNTRY, OthersMiddleware.addCountry),
    yield takeLatest(EDIT_COUNTRY, OthersMiddleware.editCountry),
    yield takeLatest(GET_CONTINENTS, OthersMiddleware.getContinents),
    yield takeLatest(GET_REGIONS, OthersMiddleware.getRegions),
    yield takeLatest(GET_ONLINE_USERS, OthersMiddleware.getOnlineUsers),
    yield takeLatest(GET_PROGRAM_TYPES, OthersMiddleware.getProgramTypes),
    yield takeLatest(GET_PROGRAMS, OthersMiddleware.getPrograms),
    yield takeLatest(UPLOAD_FILE, OthersMiddleware.uploadFile),
    yield takeLatest(UPLOAD_IMAGE, OthersMiddleware.uploadImage),
    yield takeLatest(GET_VISA_INFO, OthersMiddleware.getVisaInfo),
    yield takeLatest(EDIT_VISA_INFO, OthersMiddleware.editVisaInfo),
    yield takeLatest(ADD_VISA_INFO, OthersMiddleware.addVisaInfo),
    yield takeLatest(DELETE_VISA_INFO, OthersMiddleware.deleteVisaInfo),
    yield takeLatest(GET_TAGS, OthersMiddleware.getTags),
    yield takeLatest(GET_POPULAR_SUBS, OthersMiddleware.getPopularSubs),
    yield takeLatest(GET_PAYMENT_PLANS, OthersMiddleware.getPaymentPlans),
    yield takeLatest(GET_DIFF_UNI_VALUES, OthersMiddleware.getDiffUniValues),

    // search
    yield takeLatest(UNI_SEARCH, SearchMiddleware.uniSearch),
    yield takeLatest(EXPLORE_SEARCH, SearchMiddleware.exploreSearch),

    // schools
    yield takeLatest(GET_SCHOOL, SchoolMiddleware.getSchool),
    yield takeLatest(GET_SCHOOLS, SchoolMiddleware.getSchools),
    yield takeLatest(ADD_SCHOOL, SchoolMiddleware.addSchool),
    yield takeLatest(EDIT_SCHOOL, SchoolMiddleware.editSchool),
    yield takeLatest(CHANGE_SCHOOL_STATUS, SchoolMiddleware.changeSchoolStatus),

    // admin
    yield takeLatest(GET_DASH_INFO, AdminMiddleware.getDashInfo),
    yield takeLatest(GET_REG_PER_MONTH, AdminMiddleware.getRegPerMonth),
  ]);
}
